import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useFeatureFlag } from 'common/hooks';
import CardDataItem from './CardDataItem';
import PaymentDetails from './PaymentDetails';
import ClaimsCodes from './ClaimsCodes';
import ServiceDates from './ServiceDates';
import MetafieldDetails from './MetafieldDetails';
import FileMetadata from './FileMetadata';
import './CardData.scss';

const CardData = ({
  capInformation,
  className,
  metafields,
  providedService,
  paymentType,
  unit,
  iconStyle,
}) => {
  const showClaimsCodes = useFeatureFlag('pays-claims-codes-dropdowns');

  const {
    starts_at,
    ends_at,
    notes,
    service_duration_start_time,
    service_duration,
  } = providedService;

  return (
    <div className={cx(className, 'card-data')}>
      <div className="antialiased card-data__container space-y-2">
        <PaymentDetails
          capInformation={capInformation}
          paymentType={paymentType}
          providedService={providedService}
          unit={unit}
        />
        <CardDataItem
          dataLabel="service-period-select-value"
          label="Period of Service"
          value={!providedService.ends_at ? 'Single Date' : 'Date Range'}
        />
        {showClaimsCodes && (
          <ClaimsCodes providedService={providedService} />
        )}
        <ServiceDates
          startsAt={starts_at}
          endsAt={ends_at}
          serviceDurationStartTime={service_duration_start_time}
          serviceDuration={service_duration}
          paymentType={paymentType}
        />
        <MetafieldDetails metafields={metafields} metadata={providedService.metadata} />
        {notes && (
          <>
            <hr className="border-dark-fill-blue" />
            <CardDataItem
              dataLabel="service-note-value"
              label="Note"
              value={providedService.notes}
            />
          </>
        )}
        <FileMetadata
          fileIconStyle={iconStyle}
          metafields={metafields}
          providedService={providedService}
        />
      </div>
    </div>
  );
};

CardData.propTypes = {
  capInformation: PropTypes.string,
  className: PropTypes.string,
  iconStyle: PropTypes.object,
  metafields: PropTypes.array,
  paymentType: PropTypes.string,
  providedService: PropTypes.object.isRequired,
  unit: PropTypes.string,
};

CardData.defaultProps = {
  capInformation: '',
  className: '',
  iconStyle: {
    svg: {
      height: '18px',
      width: '14px',
      fill: '#4467AB',
    },
  },
  metafields: [],
  paymentType: '',
  unit: '',
};

export default CardData;
